<template>
  <BBModal
    class="modal-change-design d-flex align-items-center"
    class-button5="btn-change-design btn btn-outline-primary btn-lg pt-3 pb-3 pl-5 pr-5 d-flex position-absolute"
    :class-button="
      'btn h-100 btn-change-design btn-outline-primary ml-3 pt-3 pb-3 pl-3 pr-3 d-flex flex-grow-1 align-items-center justify-content-center ' +
        classButton
    "
    width="450px"
  >
    <slot />

    <template v-slot:title>
      <h3 class="main-title">{{ `Change ${changeLabel}` }}</h3>
      <span class="text-capitalize">Warning</span>
    </template>

    <template v-slot:content="slotProps">
      <div
        class="d-flex flex-column align-items-center justify-content-center pt-5 pb-4 pl-3 pr-3"
      >
        <p class="msg-text">
          {{
            `Changing ${changeLabel} will require the ${
              changeLabel === 'Roster'
                ? 'Roster and Estimate'
                : 'Design, Roster and Estimate'
            } to be re-approved`
          }}
        </p>

        <button
          class="btn btn-outline-primary btn-block pt-3 pb-3 mt-5"
          @click="slotProps.hideModal()"
        >
          Cancel
        </button>

        <button
          class="btn regular blue btn-block  pt-3 pb-3 mt-5"
          @click="changeFunction()"
        >
          {{ `Change ${changeLabel}` }}
        </button>

        <!-- <router-link
          :to="{ name: 'designPreview', params: { id: id } }"
          class="btn regular blue btn-block btn-lg pt-3 pb-3 mt-4"
        >
          <span>CHANGE DESIGN</span>
        </router-link> -->
      </div>
    </template>
  </BBModal>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component()
export default class ModalChangeDesign extends Vue {
  @Prop({
    type: String,
    required: false,
    default: null
  })
  id

  @Prop({
    type: String,
    required: false,
    default: null
  })
  orderId

  @Prop({
    type: String,
    required: false,
    default: ''
  })
  classButton

  @Prop({
    type: String,
    required: false,
    default: 'design'
  })
  changeLabel

  @Prop({
    type: Function,
    required: false,
    default: null
  })
  onChange

  changeFunction() {
    if (this.onChange) {
      this.onChange()
    } else {
      this.onChangeDesign()
    }
  }

  onChangeDesign() {
    const routeName = this.orderId ? 'designOrder' : 'designPreview'

    this.saveChangeDesign({
      routeName: routeName
    }).then(() => {
      this.$router.push({
        name: routeName,
        params: { id: this.id }
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.modal-change-design {
  /deep/ .btn-change-design {
    right: 0;
  }

  .main-title {
    font-size: 24px;
    text-transform: capitalize;
  }

  .msg-text {
    font-size: 19px;
    font-weight: normal;
    line-height: 1.5;
    text-align-last: left;
    text-transform: none;
    color: #6d6c6c;
  }

  .btn {
    text-decoration: none;
  }
}
</style>
